import { StyleSheet, View } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { Palette } from '@/constants/theme';
import { useAppTheme } from '@/theme/app-theme';

// Light theme keeps the two-tone navy + brand blue. In dark theme the navy
// "opn" disappears against the dark background, so both use a brighter, clearly
// visible blue.
const LIGHT_LEAD = '#092D5B';
const LIGHT_BLUE = '#2468D4';
const DARK_LEAD = '#CBDDFA';
const DARK_BLUE = '#6EA8FF';

/**
 * opncue. wordmark:
 * "opn" in the lead color, "cue" in brand blue, with a blue pulse dot.
 */
export function Logo({ size = 30 }: { size?: number }) {
  const { isDark } = useAppTheme();
  const lead = isDark ? DARK_LEAD : LIGHT_LEAD;
  const blue = isDark ? DARK_BLUE : LIGHT_BLUE;

  return (
    <View style={styles.row}>
      <ThemedText
        style={[
          styles.word,
          {
            fontSize: size,
            lineHeight: size * 1.15,
            color: lead,
          },
        ]}>
        opn
      </ThemedText>

      <ThemedText
        style={[
          styles.word,
          {
            fontSize: size,
            lineHeight: size * 1.15,
            color: blue,
          },
        ]}>
        cue
      </ThemedText>

      <View
        style={[
          styles.dot,
          {
            backgroundColor: blue,
            width: Math.max(6, size * 0.22),
            height: Math.max(6, size * 0.22),
            borderRadius: Math.max(3, size * 0.11),
            marginTop: size * 0.27,
          },
        ]}
      />
    </View>
  );
}

/** Square app mark for splash screens and headers. */
export function LogoMark({ size = 64 }: { size?: number }) {
  return (
    <View
      style={[
        styles.mark,
        {
          width: size,
          height: size,
          borderRadius: size * 0.28,
          backgroundColor: Palette.blue,
        },
      ]}>
      <View
        style={[
          styles.ring,
          {
            width: size * 0.46,
            height: size * 0.46,
            borderRadius: size * 0.23,
          },
        ]}
      />

      <View
        style={[
          styles.core,
          {
            width: size * 0.16,
            height: size * 0.16,
            borderRadius: size * 0.08,
          },
        ]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },

  word: {
    fontWeight: '500',
    letterSpacing: -1.5,
  },

  dot: {
    marginLeft: 3,
  },

  mark: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  ring: {
    position: 'absolute',
    borderWidth: 3,
    borderColor: 'rgba(255,255,255,0.65)',
  },

  core: {
    backgroundColor: '#FFFFFF',
  },
});